import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Row } from '~/commonComponents';
import CloseIcon from '~/images/icons/CloseIcon';

interface IProcedurePillProps {
  label: string;
  onRemove: () => void;
}

export const ProcedurePill = ({ label, onRemove }: IProcedurePillProps) => {
  return (
    <Row
      data-testid="procedure-pill"
      data-cy="procedure-pill"
      alignItems="center"
      gap={8}
      style={{
        backgroundColor: colors.primary[50],
        border: `1.5px solid ${colors.secondary[500]}`,
        borderRadius: 36,
        height: 38,
        padding: '0px 12px',
        animation: 'pillFadeIn 0.25s ease-out',
      }}
    >
      <Typography as="span" size="body_large" style={{ whiteSpace: 'nowrap', fontWeight: 400 }}>
        {label}
      </Typography>
      <Row
        data-testid="remove-procedure"
        data-cy="remove-procedure"
        onClick={onRemove}
        alignItems="center"
        style={{ cursor: 'pointer' }}
      >
        <CloseIcon color={colors.secondary[500]} width={16} height={16} />
      </Row>
    </Row>
  );
};
